import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import Badge from "shared/Badge/Badge";
// import SectionDateRange from "../SectionDateRange";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
//@ts-ignore
import { Squares2X2Icon } from "@heroicons/react/24/outline";

import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import { getallupdateProperties } from "../../../redux/reducers/Properties/PropertiesSlice";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "redux/store";
import { useSelector } from "react-redux";
import { PropertyToEdit } from "redux/reducers/Properties/PropertiesSliceTypes";
import { reserveBooking } from "../../../redux/reducers/Payments/PaymentReducer";
import ContactOwnerModal from "./contact-owner";
import successHandler from "utils/helpers/SuccessHandler";
import ErrorHandler from "utils/helpers/ErrorHandler";
import SelectGuests from "./SelectGuests";
import moment from "moment";
import { useFormik } from "formik";
import FormItem from "containers/PageAddListing1/FormItem";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import NcImage from "shared/NcImage/NcImage";
import { currencySymbol } from "shared/CurrencySymbol";
import { eachDayOfInterval } from "date-fns";
import { isAuthenticated } from "utils/helpers/CommonHelper";
import CommonModal from "shared/Modal/CommonModal";
import ListingStayDetailSkeleton from "shared/Skelton/ListingDetailPageSkelton";
import "@mantine/dates/styles.css";
import CustomDatePickerV2 from "shared/DateField/CustomDatePickerV2";
import RenderSectionDetails from "./ListingStayDetailsPage/RenderSectionDetails";
import PropertyDescription from "./ListingStayDetailsPage/PropertyDescription";
import FinancialDetails from "./ListingStayDetailsPage/FinancialDetails";
import Recommendations from "./ListingStayDetailsPage/Recommendations";
import AmenitiesFeatures from "./ListingStayDetailsPage/AmenitiesFeatures";
import HostInformation from "./ListingStayDetailsPage/HostInformation";
import Review from "./ListingStayDetailsPage/Review";
import ListingMap from "./ListingStayDetailsPage/ListingMap";
import Cancellation from "./ListingStayDetailsPage/Cancellation";
import Policy from "./ListingStayDetailsPage/Policy";
import Universities from "./ListingStayDetailsPage/Universities";
import Roomies from "./ListingStayDetailsPage/Roomies";
import PropertyImageGallery from "./ListingStayDetailsPage/Propertyimagegallery";
import SimilarProperty from "./ListingStayDetailsPage/SimilarProperty";
import SectionDateRange from "../SectionDateRange";
import ImageModal from "./ImageModal";
import { Tooltip } from "react-tooltip";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { getIconComponent } from "shared/Icon/IconDymamiclisting";
import StartRating from "components/StartRating/StartRating";
import { Dialog, Transition } from "@headlessui/react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import RoomsListSection from "components/Rooms/RoomList";
import AvailabilitySidebar from "components/AvailabilitySidebar";
import BookingSideBar from "components/Booking/BookingSidebar";
import { ChevronUp, Calendar, DollarSign } from "lucide-react";
import SEO from "components/SEO/SEO";
import JsonLd from "components/JsonLd/JsonLd";

const StayDetailPageContainer: FC<{}> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [propertyData, setPropertyData] = useState<PropertyToEdit | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { globalId } = useSelector((state: RootState) => state.property);
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const navigatedFrom = searchParams.get("navigatedFrom");
  const roomId = searchParams.get("room");
  //const sortAddress = `${propertyData?.city}, ${propertyData?.state}`;
  const sortAddress = [
  propertyData?.neighborhood,
  propertyData?.city,
  propertyData?.state
].filter(Boolean).join(', ');
  const roomRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const [roomsRendered, setRoomsRendered] = useState(false);
  // NEW: State to track selected room at the top level
  const [selectedRoom, setSelectedRoom] = useState<
    PropertyToEdit["rooms"][number] | null
  >(null);
  const [isMobileSheetOpen, setIsMobileSheetOpen] = useState(false);

  useEffect(() => {
    if (roomId && roomsRendered && roomRefs.current[roomId]) {
      setTimeout(() => {
        roomRefs.current[roomId]?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [roomId, roomsRendered]);

  useEffect(() => {
    if (propertyData && propertyData.rooms && propertyData.rooms.length > 0) {
      setRoomsRendered(true);
    }
  }, [propertyData?.rooms]);

  const storedSearchData = useSelector(
    (state: RootState) => state.search.searchedData
  );
  const { startDate: start } = storedSearchData || {};
  const formattedDate = moment(start).format("MMM DD,YYYY");
  const id = slug;
  const propertyId = globalId || slug;

  const propertySlug = slug || propertyData?.slug;
  const defaultImage =
    "https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
  const [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentUser } = useSelector((state: RootState) => state.user);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userLocation, setUserLocation] = useState<{
    lat: number;
    lng: number;
  }>({ lat: 38.9072, lng: -77.0369 });

  const [modalDescription, setModalDescription] = useState("");
  const [infoModal, setInfoModal] = useState(false);
  const [imageModal, setIsOpenImageModal] = useState(false);

  const handleChatButtonClick = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleSendMessage = (data: any) => {
    setIsModalOpen(false);
  };

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModalImageGallery = () => {
    setIsOpenImageModal(true);
  };

  function closeImageModal() {
    setIsOpenImageModal(false);
  }

  const handleRoomSelect = (room: PropertyToEdit["rooms"][number]) => {
    setSelectedRoom(room);
    console.log("Room selected in parent:", room);
  };

  useEffect(() => {
    const fetchPropertyData = async () => {
      if (propertyId || id) {
        try {
          setLoading(true);
          const queryParams = navigatedFrom
            ? storedSearchData
              ? {
                  start_date: storedSearchData?.startDate || "",
                  end_date: storedSearchData?.endDate || "",
                  room_type_ids: storedSearchData?.roomTypeId || "",
                }
              : undefined
            : undefined;
          const response: any = await dispatch(
            getallupdateProperties({
              propertyId,
              queryParams,
            })
          );

          const property = response.payload?.property;
          const { latitude, longitude } = property;

          setUserLocation({ lat: Number(latitude), lng: Number(longitude) });

          if (property) {
            setPropertyData(property);
          } else {
            console.error("Property not found:", response);
          }
        } catch (error) {
          console.error("Error fetching property data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPropertyData();
  }, [propertyId, id, dispatch]);

  // 👇 Add this below
  useEffect(() => {
    if (propertyData) {
      console.log("📦 Property Data:", propertyData);
    }
  }, [propertyData]);

  // 👇 ADD THIS useEffect after your other useEffect hooks
  useEffect(() => {
    // Auto-open booking sheet on mobile when room is selected
    if (selectedRoom && window.innerWidth < 1024) {
      setIsMobileSheetOpen(true);
    }
  }, [selectedRoom]);

  useEffect(() => {
    if (propertyData && propertyData.rooms) {
      console.log("🏠 Property:", propertyData);
      console.log("🛏️ Rooms:", propertyData.rooms);

      propertyData.rooms.forEach((room: any) => {
        console.log(
          `Room ID: ${room.id}, Name: ${room.name}, Start: ${room.availability_start}, End: ${room.availability_end}`
        );
      });
    }
  }, [propertyData]);

  if (loading) {
    return <ListingStayDetailSkeleton propertyData={propertyData} />;
  }

  const RenderSection9 = () => {
    const [error, setError] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentRoomId, setCurrentRoomId] = useState<any>(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [currentRoom, setCurrentRoom] = useState<any>(null);
    const [loadingRoomId, setLoadingRoomId] = useState<number | null>(null);
    const location = useLocation();
    dayjs.extend(isBetween);
    const maximumGuests = currentRoom && Number(currentRoom.max_guests);
    const [isRoomAmenitiesModalOpen, setIsRoomAmenitiesModalOpen] =
      useState(false);
    const [currentRoomAmenities, setCurrentRoomAmenities] = useState<any>(null);
    const isGuestAllowed = propertyData?.allow_extra_guest;
    const serviceFeesPercentage = propertyData?.service_fee;
    const perExtraAmount = propertyData?.per_extra_guest_amount;

    const openRoomAmenitiesModal = (room: any) => {
      setCurrentRoomAmenities(room);
      setIsRoomAmenitiesModalOpen(true);
    };

    const closeRoomAmenitiesModal = () => {
      setIsRoomAmenitiesModalOpen(false);
      setCurrentRoomAmenities(null);
    };

    const formik = useFormik({
      initialValues: {
        number_of_guests: null,
        booking_start: null,
        booking_end: null,
        room_id: null,
        line_items_attributes: [],
        price_per_month: null,
      },
      enableReinitialize: true,
      onSubmit: (values, { resetForm }) => {
        if (!isAuthenticated()) {
          navigate("/login", { state: { from: location.pathname } });
          return;
        }

        if (!currentUser?.profile_complete) {
          setInfoModal(true);
          setModalDescription(
            "Please complete your profile before making a booking."
          );
          return;
        }

        if (formik.values.room_id !== null) {
          handleSubmit(values, formik.values.room_id, resetForm);
        } else {
          setError("Please select a valid room.");
        }
      },
    });

    const extraGuest =
      isGuestAllowed &&
      formik.values.number_of_guests &&
      formik.values.number_of_guests > maximumGuests &&
      formik.values.number_of_guests - maximumGuests;

    const extraAmount = Number(extraGuest) * Number(perExtraAmount);
    const partialTotal =
      Number(currentRoom?.price_per_month) + Number(extraAmount);
    const serviceFees = (partialTotal * Number(serviceFeesPercentage)) / 100;
    const totalAmount = Number(partialTotal) + Number(serviceFees);
    const startDate = formik.values.booking_start;
    const endDate = formik.values.booking_end;

    const calculateMonthsDifference = (
      bookingStart: string,
      bookingEnd: string
    ): number => {
      const start = moment(bookingStart, "YYYY-MM-DD");
      const end = moment(bookingEnd, "YYYY-MM-DD");
      
      // Calculate decimal months
      const months = end.diff(start, 'months', true);
      
      // Round up - any partial month counts as full month
      return Math.ceil(months);
    };

    const handleSubmit = async (
      values: any,
      roomId: number,
      resetForm: () => void
    ) => {
      const postData = {
        booking: {
          number_of_guests: Number(values.number_of_guests),
          property_id: propertyId,
          service_fee_amount: serviceFees,
          check_in_date: moment(values.booking_start).format("YYYY-MM-DD"),
          check_out_date: moment(values.booking_end).format("YYYY-MM-DD"),
          extra_guest_amount: extraAmount,
          no_of_months: calculateMonthsDifference(
            moment(values.booking_start).format("YYYY-MM-DD"),
            moment(values.booking_end).format("YYYY-MM-DD")
          ),
          line_items_attributes: [
            {
              room_id: values.room_id,
              price: values.price_per_month,
              quantity: 1,
              property_id: propertyId,
            },
          ],
        },
      };

      setLoadingRoomId(roomId);
      try {
        const action = await dispatch(reserveBooking(postData as any));
        if (action?.type === "payment/reserveBooking/fulfilled") {
          successHandler(
            "Booking request sent. Please wait for owner's confirmation!"
          );
          resetForm();
        }
      } catch (error) {
        ErrorHandler("Failed to reserve booking. Please try again.");
      } finally {
        setLoadingRoomId(null);
      }
    };

    const modifiedStatus = (status: string | undefined) => {
      switch (status) {
        case "active":
          return "Active";
        case "inactive":
          return "Inactive";
        default:
          return "";
      }
    };

    useEffect(() => {
      const { booking_start, booking_end, number_of_guests } = formik.values;
      if (booking_start && booking_end && number_of_guests) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }, [formik.values]);

    const selectedRoom = formik?.values?.room_id;

    const handleContactOwner = (roomId: number) => {
      setCurrentRoomId(roomId);
      setIsModalOpen(true);
    };
    const handleCloseModal = () => {
      setIsModalOpen(false);
    };

    const getDisabledDates = (booked_dates: [string, string][]) => {
      const disabledDates: Date[] = [];

      booked_dates.forEach(([startDate, endDate]) => {
        if (startDate && endDate) {
          const dateRange = eachDayOfInterval({
            start: moment(startDate).toDate(),
            end: moment(endDate).toDate(),
          });
          disabledDates.push(...dateRange);
        }
      });

      return disabledDates;
    };

    if (!propertyData) return null;
    return (
      <div className="">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mb-4">
          Rooms
        </h2>
        {propertyData?.rooms
          .filter((room) => room.status !== "inactive")
          .map((room, index) => (
            <div
              style={{ marginTop: "0" }}
              ref={(el) => {
                roomRefs.current[room.id] = el;
                if (
                  el &&
                  roomId &&
                  String(room.id) === roomId &&
                  roomsRendered
                ) {
                  el.style.scrollMarginTop = "100px";
                  setTimeout(() => {
                    el.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }, 1000);
                }
              }}
              key={room.id}
              className={`${
                propertyData?.is_shared_property
                  ? "flex flex-col lg:flex-row gap-4 w-full justify-between rounded-2xl border border-gray-300 dark:border-gray-600 p-5 mb-5 shadow-lg"
                  : "flex flex-col lg:flex-row gap-4 w-full justify-between rounded-2xl border border-gray-300 dark:border-gray-600 p-5 mb-5 shadow-lg"
              }`}
            >
              <div
                className={`w-full ${
                  propertyData?.is_shared_property
                    ? "lg:w-3/4 lg:pr-4 pr-0"
                    : ""
                }`}
              >
                <div className="mb-5"></div>
                <div className="flex flex-col md:flex-row gap-6 rounded-lg mb-6">
                  <div className="relative w-full md:w-1/2">
                    <div className=" relative aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
                      <GallerySlider
                        uniqueID={`ExperiencesCard_${id}`}
                        ratioClass="aspect-w-4 aspect-h-3"
                        galleryImgs={room?.room_images.map(
                          (image) => image.url
                        )}
                        href="#"
                      />
                    </div>
                    <Badge
                      name={modifiedStatus(room?.status) || "Property"}
                      className="absolute left-3 top-3 z-[1]"
                    />
                  </div>
                  <div className="w-full md:w-1/2 text-neutral-700 dark:text-neutral-300">
                    <div className="flex flex-col md:flex-row md:items-start justify-between mb-4">
                      <h2 className="text-lg font-semibold line-clamp-2 dark:text-white">
                        {room?.name}
                      </h2>
                    </div>
                    <div className="space-y-2 mt-2 text-neutral-600 dark:text-neutral-400 text-sm">
                      <div className="flex flex-wrap items-center gap-4">
                        {room.max_guests && (
                          <div className="min-w-[150px] flex items-center gap-2">
                            <i className="las la-user text-2xl"></i>
                            <span>Guests {room.max_guests}</span>
                          </div>
                        )}
                        {room.bed_type?.name && (
                          <div className="min-w-[150px] flex items-center gap-2">
                            <i className="las la-bed text-2xl"></i>
                            <span>{room.bed_type.name}</span>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-wrap items-center gap-4">
                        {room.room_type?.name && (
                          <div className="min-w-[150px] flex items-center gap-2">
                            <i className="las la-door-open text-2xl"></i>
                            <span>{room.room_type.name}</span>
                          </div>
                        )}

                        {room.size && (
                          <div className="min-w-[150px] flex items-center gap-2">
                            <i className="las la-expand-arrows-alt text-2xl"></i>
                            <span>{room.size} sq ft</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <hr className="h-px my-5 bg-gray-200 border-0 dark:bg-gray-700" />
                    <div className="mt-4">
                      <div className="flex flex-wrap gap-y-4 gap-x-6">
                        {(() => {
                          const allAmenities = [
                            ...(room?.features || []),
                            ...(room?.amenities || []),
                          ];
                          const showViewMore = allAmenities?.length > 4;
                          const displayItems = showViewMore
                            ? allAmenities.slice(0, 4)
                            : allAmenities;
                          return (
                            <>
                              {displayItems.map((item, index) => {
                                const Icon = getIconComponent(
                                  item?.icon_name || ""
                                );
                                return (
                                  <div
                                    key={item.id || index}
                                    className="min-w-[140px] flex items-center gap-2"
                                  >
                                    {item?.image ? (
                                      <NcImage
                                        src={item?.image}
                                        alt={item?.name}
                                        className="w-8 h-8 object-cover rounded-md"
                                      />
                                    ) : (
                                      <Icon className="text-2xl text-neutral-700 dark:text-neutral-300" />
                                    )}
                                    <span className="text-sm text-neutral-700 dark:text-neutral-300">
                                      {item?.name}
                                    </span>
                                  </div>
                                );
                              })}
                              {showViewMore && (
                                <div className="min-w-[140px] flex items-center gap-2">
                                  <button
                                    onClick={() => openRoomAmenitiesModal(room)}
                                    className="text-sm text-orange-500 hover:text-orange-800 underline"
                                  >
                                    View more amenities & features
                                  </button>
                                </div>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                    {isRoomAmenitiesModalOpen && currentRoomAmenities && (
                      <Transition
                        appear
                        show={isRoomAmenitiesModalOpen}
                        as={Fragment}
                      >
                        <Dialog
                          as="div"
                          className="fixed inset-0 z-50 overflow-y-auto"
                          onClose={closeRoomAmenitiesModal}
                        >
                          <div className="min-h-screen px-4 text-center">
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0"
                              enterTo="opacity-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                            </Transition.Child>

                            <span
                              className="inline-block h-screen align-middle"
                              aria-hidden="true"
                            >
                              &#8203;
                            </span>

                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 scale-95"
                              enterTo="opacity-100 scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 scale-100"
                              leaveTo="opacity-0 scale-95"
                            >
                              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white truncate max-w-[80%] mx-auto">
                                      {currentRoomAmenities?.name}
                                    </h3>
                                    <span className="absolute left-3 top-3">
                                      <ButtonClose
                                        onClick={closeRoomAmenitiesModal}
                                      />
                                    </span>
                                  </div>

                                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                                    {[
                                      ...(currentRoomAmenities?.features || []),
                                      ...(currentRoomAmenities?.amenities ||
                                        []),
                                    ].map((item, index) => {
                                      const Icon = getIconComponent(
                                        item?.icon_name || ""
                                      );
                                      return (
                                        <div
                                          key={item?.id || index}
                                          className="flex items-center space-x-3 p-3"
                                        >
                                          {item?.image ? (
                                            <NcImage
                                              src={item?.image}
                                              alt={item?.name}
                                              className="w-8 h-8 object-cover rounded-md"
                                            />
                                          ) : (
                                            <Icon className="text-2xl" />
                                          )}
                                          <span>{item?.name}</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </Transition.Child>
                          </div>
                        </Dialog>
                      </Transition>
                    )}
                  </div>
                </div>
                {room?.description && (
                  <div className="mt-8">
                    <h2 className="text-xl font-semibold mb-4">
                      Room Description
                    </h2>
                    <div className="text-neutral-600 dark:text-neutral-300 break-words font-light">
                      <span>{room.description}</span>
                    </div>
                  </div>
                )}
                {/* {propertyData.is_shared_property && (
                <SectionDateRange
                  availabilityStart={moment(
                    moment(room.booking_start).isAfter(moment())
                      ? room.booking_start
                      : new Date()
                  ).toDate()}
                  availabilityEnd={
                    room.booking_end
                      ? moment(room.booking_end).toDate()
                      : undefined
                  }
                  booked_dates={room.booked_dates}
                />
              )} */}
              </div>
              <div
                className={`${
                  propertyData?.is_shared_property
                    ? "w-full lg:w-1.8/4 pt-4"
                    : ""
                }`}
              >
                {propertyData?.is_shared_property && (
                  <div className="listingSectionSidebar__wrap shadow-sm">
                    {room.status === "inactive" && (
                      <span className="inline-block w-fit px-3 py-1 text-sm font-medium text-red-700 bg-red-100 border border-red-300 rounded-full whitespace-nowrap overflow-hidden text-ellipsis">
                        Room is Inactive
                      </span>
                    )}
                    {!room?.to_book && (
                      <div className="flex justify-start align-baseline">
                        <Badge
                          name={
                            !room?.to_book
                              ? `Available From - ${
                                  room?.next_available_date || "N/A"
                                }`
                              : room?.next_available_date || "Category"
                          }
                        />
                      </div>
                    )}
                    <div className="flex justify-between">
                      <span className="text-3xl font-semibold">
                        {`${currencySymbol()} ${
                          Number(room?.price_per_month)?.toFixed(2) || 0
                        }`}
                        /month
                      </span>
                    </div>
                    <form
                      onSubmit={formik.handleSubmit}
                      className="flex flex-col rounded-3xl !mt-0"
                    >
                      <div className="">
                        <CustomDatePickerV2
                          label="Availability Start Date"
                          placeholder="Availability Start Date"
                          disabled={
                            (typeof room?.next_available_date === "string" &&
                              room?.next_available_date !== formattedDate) ||
                            room.status === "inactive"
                          }
                          value={
                            selectedRoom === room.id &&
                            formik.values.booking_start
                              ? moment(formik.values.booking_start)
                              : null
                          }
                          onChange={(value) => {
                            setError("");
                            formik.setFieldValue("booking_start", value);
                            formik.setFieldValue("booking_end", null);
                            formik.setFieldValue("number_of_guests", null);
                            formik.setFieldValue("room_id", room.id);
                            formik.setFieldValue(
                              "price_per_month",
                              room.price_per_month
                            );
                            formik.setFieldValue(
                              "booking_end",
                              selectedRoom !== room.id && undefined
                            );
                            formik.setFieldValue(
                              "number_of_guests",
                              selectedRoom !== room.id && null
                            );
                          }}
                          minDate={moment(
                            moment(
                              room?.availability_start ??
                                propertyData?.availability_start
                            ).isAfter(moment())
                              ? room?.availability_start ??
                                  propertyData?.availability_start
                              : new Date()
                          ).toDate()}
                          maxDate={
                            room?.availability_end
                              ? moment(room?.availability_end).toDate()
                              : propertyData?.availability_end
                              ? moment(propertyData?.availability_end).toDate()
                              : undefined
                          }
                          excludeDate={(date) => {
                            const disabledDates = getDisabledDates(
                              room.booked_dates
                            );
                            return disabledDates.some(
                              (disabledDate) =>
                                date.getFullYear() ===
                                  disabledDate.getFullYear() &&
                                date.getMonth() === disabledDate.getMonth() &&
                                date.getDate() === disabledDate.getDate()
                            );
                          }}
                        />
                        <CustomDatePickerV2
                          label="Availability End Date"
                          placeholder="Availability End Date"
                          disabled={
                            (typeof room?.next_available_date === "string" &&
                              room.next_available_date !== formattedDate) ||
                            room.status === "inactive"
                          }
                          value={
                            selectedRoom === room.id &&
                            formik.values.booking_end
                              ? moment(formik.values.booking_end)
                              : null
                          }
                          onChange={(value) => {
                            setError("");
                            formik.setFieldValue("room_id", room.id);
                            formik.setFieldValue(
                              "price_per_month",
                              room.price_per_month
                            );
                            formik.setFieldValue(
                              "booking_end",
                              selectedRoom !== room.id && undefined
                            );
                            formik.setFieldValue(
                              "number_of_guests",
                              selectedRoom !== room.id && null
                            );
                            formik.setFieldValue("booking_end", value);
                            setCurrentRoom(room);
                          }}
                          minDate={
                            formik.values.booking_start
                              ? moment(formik.values.booking_start)
                                  .add(1, "day")
                                  .toDate()
                              : moment(
                                  moment(
                                    room?.availability_start ??
                                      propertyData?.availability_start
                                  ).isAfter(moment())
                                    ? room?.availability_start ??
                                        propertyData?.availability_start
                                    : new Date()
                                ).toDate()
                          }
                          maxDate={
                            room?.availability_end
                              ? moment(room?.availability_end).toDate()
                              : propertyData?.availability_end
                              ? moment(propertyData?.availability_end).toDate()
                              : undefined
                          }
                          excludeDate={(date) => {
                            const disabledDates = getDisabledDates(
                              room.booked_dates
                            );
                            return disabledDates.some(
                              (disabledDate) =>
                                date.getFullYear() ===
                                  disabledDate.getFullYear() &&
                                date.getMonth() === disabledDate.getMonth() &&
                                date.getDate() === disabledDate.getDate()
                            );
                          }}
                        />
                        {selectedRoom === room.id && (
                          <span className="text-red-500 text-xs">{error}</span>
                        )}

                        <FormItem label="Select Guest" className="mt-4">
                          <SelectGuests
                            className={"flex-1"}
                            room={room}
                            maxGuests={isGuestAllowed ? 15 : room?.max_guests}
                            formik={formik}
                            disabled={
                              (typeof room?.next_available_date === "string" &&
                                room.next_available_date !== formattedDate) ||
                              room?.status === "inactive"
                            }
                          />
                        </FormItem>
                      </div>
                    </form>
                    {startDate && endDate && selectedRoom === room.id && (
                      <div className="flex flex-col space-y-4">
                        <div className="border-b border-neutral-200 dark:border-neutral-700" />
                        <div className="flex justify-between text-neutral-600 dark:text-neutral-300">
                          <div className="flex items-center space-x-2">
                            <span className="text-lg font-medium">
                              First Month Rent
                            </span>
                            <div className="relative flex items-center">
                              <i
                                data-tooltip-id="info-tooltip"
                                className="text-2xl las la-info-circle"
                              ></i>

                              <Tooltip
                                id="info-tooltip"
                                place="top"
                                content="This deposit will be transfered to host until 24 hours after your check in to the property"
                                noArrow={false}
                                style={{
                                  backgroundColor: "#f97316",
                                  color: "white",
                                  borderRadius: "0.375rem",
                                  padding: "0.25rem 0.5rem",
                                  maxWidth: "150px",
                                  textAlign: "center",
                                  fontSize: "0.75rem",
                                }}
                              />
                            </div>
                          </div>
                          <span>
                            {`${currencySymbol()} ${
                              Number(room?.price_per_month)?.toFixed(2) || 0
                            }`}
                          </span>
                        </div>
                        {isGuestAllowed && extraGuest && (
                          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                            <span>Cost of {extraGuest} extra guests</span>
                            <span>
                              {`${currencySymbol()} ${
                                Number(extraAmount)?.toFixed(2) || 0
                              }`}
                            </span>
                          </div>
                        )}
                        <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                          <div className="flex items-center space-x-2">
                            <span className="text-lg font-medium">
                              One-Time Service fee
                            </span>
                            <div className="relative flex items-center">
                              <i
                                data-tooltip-id="tooltip-service-fee"
                                className="text-2xl las la-question-circle cursor-pointer"
                              ></i>

                              <Tooltip
                                id="tooltip-service-fee"
                                place="top"
                                content="This is a one-time fee that allows us to provide assistance and customer support. Furthermore, secure your payment and guarantee your accommodation."
                                noArrow={false}
                                style={{
                                  backgroundColor: "#f97316",
                                  color: "white",
                                  borderRadius: "0.375rem",
                                  padding: "0.25rem 0.5rem",
                                  maxWidth: "150px",
                                  textAlign: "center",
                                  fontSize: "0.75rem",
                                }}
                              />
                            </div>
                          </div>

                          <span>
                            {`${currencySymbol()} ${
                              Number(serviceFees)?.toFixed(2) || 0
                            }`}
                          </span>
                        </div>
                        <div className="flex justify-between font-semibold">
                          <span>Total</span>
                          <span>
                            {`${currencySymbol()} ${
                              Number(totalAmount)?.toFixed(2) || 0
                            }`}
                          </span>
                        </div>
                      </div>
                    )}
                    <ButtonPrimary
                      onClick={() => {
                        formik.setFieldValue("room_id", room.id);
                        formik.handleSubmit();
                      }}
                      loading={loadingRoomId === room.id}
                      disabled={
                        (selectedRoom === room.id ? isButtonDisabled : true) ||
                        room.status === "inactive"
                      }
                    >
                      Reserve
                    </ButtonPrimary>
                    <ButtonPrimary
                      onClick={() => handleContactOwner(room.id)}
                      disabled={
                        !isAuthenticated() ||
                        (typeof room?.next_available_date === "string" &&
                          room.next_available_date !== formattedDate) ||
                        room.status === "inactive"
                      }
                    >
                      Contact Host
                    </ButtonPrimary>
                    {infoModal && (
                      <CommonModal
                        isOpen={infoModal}
                        onClose={() => setInfoModal(false)}
                        description={modalDescription}
                      />
                    )}
                    {isModalOpen && (
                      <ContactOwnerModal
                        currentRoomId={currentRoomId}
                        isOpen={isModalOpen}
                        onClose={handleCloseModal}
                        onSend={handleCloseModal}
                        propertyData={propertyData}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    );
  };

  const RenderSidebar = () => {
    dayjs.extend(isBetween);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [error, setError] = useState("");
    const location = useLocation();
    const isGuestAllowed = propertyData?.allow_extra_guest;
    const maximumGuests = Number(propertyData?.guest_number);
    const pricePerMonth = propertyData?.price_per_month;
    const serviceFeesPercentage = propertyData?.service_fee;
    const perExtraAmount = propertyData?.per_extra_guest_amount;

    const formik = useFormik({
      initialValues: {
        number_of_guests: null,
        check_in_date: null,
        check_out_date: null,
        availability_start: null,
        availability_end: null,
        unlimited_availability: false,
        minimum_months_of_booking: 0,
        room_id: null,
      },
      enableReinitialize: true,
      onSubmit: (values) => handleSubmit(values),
    });

    const extraGuest =
      isGuestAllowed &&
      formik.values.number_of_guests &&
      formik.values.number_of_guests > maximumGuests &&
      formik.values.number_of_guests - maximumGuests;

    const extraAmount = Number(extraGuest) * Number(perExtraAmount);
    const partialTotal = Number(pricePerMonth) + Number(extraAmount);
    const serviceFees = (partialTotal * Number(serviceFeesPercentage)) / 100;
    const totalAmount = Number(partialTotal) + Number(serviceFees);
    const startDate = formik.values.check_in_date;
    const endDate = formik.values.check_out_date;

    const handleSubmit = async (values: any) => {
      if (!isAuthenticated()) {
        navigate("/login", { state: { from: location.pathname } });
        return;
      }

      const calculateMonthsDifference = (
        checkInDate: string,
        checkOutDate: string
      ): number => {
        const start = moment(checkInDate, "YYYY-MM-DD");
        const end = moment(checkOutDate, "YYYY-MM-DD");
        const uniqueMonths = new Set();
        let current = start.clone();
        while (current.isBefore(end, "day") || current.isSame(end, "day")) {
          uniqueMonths.add(`${current.year()}-${current.month() + 1}`);
          current.add(1, "day");
        }

        return uniqueMonths.size;
      };

      if (!currentUser?.profile_complete) {
        setInfoModal(true);
        setModalDescription(
          "Please complete your profile before making a booking."
        );
        return;
      }
      setIsLoading(true);
      try {
        const postData = {
          booking: {
            number_of_guests: Number(values.number_of_guests),
            service_fee_amount: serviceFees,
            property_id: propertyId,
            extra_guest_amount: extraAmount,
            check_in_date: moment(values.check_in_date).format("YYYY-MM-DD"),
            check_out_date: moment(values.check_out_date).format("YYYY-MM-DD"),
            no_of_months: calculateMonthsDifference(
              moment(values.check_in_date).format("YYYY-MM-DD"),
              moment(values.check_out_date).format("YYYY-MM-DD")
            ),
          },
        };
        const action = await dispatch(reserveBooking(postData as any));
        if (action?.type === "payment/reserveBooking/fulfilled" && action) {
          successHandler(
            "Booking request sent. Please wait for the owner's confirmation!"
          );
        }
      } catch (error) {
        ErrorHandler("Failed to reserve booking. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      const { check_in_date, check_out_date, number_of_guests } = formik.values;
      if (check_in_date && check_out_date && number_of_guests) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }, [formik.values]);

    const getDisabledDates = (booked_dates: [string, string][]) => {
      const disabledDates: Date[] = [];

      booked_dates.forEach(([startDate, endDate]) => {
        if (startDate && endDate) {
          const dateRange = eachDayOfInterval({
            start: moment(startDate).toDate(),
            end: moment(endDate).toDate(),
          });
          disabledDates.push(...dateRange);
        }
      });

      return disabledDates;
    };

    if (!propertyData) return null;

    return (
      <>
        <div className="listingSectionSidebar__wrap shadow-xl">
          {/* PRICE */}
          <div className="flex justify-between">
            <span className="text-3xl font-semibold text-black dark:text-neutral-400">
              {`${currencySymbol()} ${
                Number(propertyData?.price_per_month)?.toFixed(2) || 0
              }`}
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                /month
              </span>
            </span>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <CustomDatePickerV2
              label="Availability Start Date"
              placeholder="Availability Start Date"
              disabled={
                typeof propertyData?.next_available_date === "string" &&
                propertyData.next_available_date !== formattedDate
              }
              value={formik.values.check_in_date}
              onChange={(value) => {
                formik.setFieldValue("check_in_date", value);
                formik.setFieldValue("check_out_date", null);
                formik.setFieldValue("number_of_guests", null);
              }}
              minDate={moment(
                moment(propertyData?.availability_start).isAfter(moment())
                  ? propertyData?.availability_start
                  : new Date()
              ).toDate()}
              maxDate={
                propertyData?.availability_end
                  ? moment(propertyData?.availability_end).toDate()
                  : undefined
              }
              excludeDate={(date) => {
                const disabledDates = getDisabledDates(
                  propertyData.booked_dates
                );
                return disabledDates.some(
                  (disabledDate) =>
                    date.getFullYear() === disabledDate.getFullYear() &&
                    date.getMonth() === disabledDate.getMonth() &&
                    date.getDate() === disabledDate.getDate()
                );
              }}
            />

            <CustomDatePickerV2
              label="Availability End Date"
              placeholder="Availability End Date"
              disabled={
                typeof propertyData?.next_available_date === "string" &&
                propertyData.next_available_date !== formattedDate
              }
              value={formik.values.check_out_date || null}
              onChange={(value) => {
                formik.setFieldValue("check_out_date", value);
              }}
              minDate={
                formik.values.check_in_date
                  ? moment(formik.values.check_in_date).add(1, "day").toDate()
                  : moment(propertyData?.availability_start).isAfter(moment())
                  ? moment(propertyData?.availability_start).toDate()
                  : new Date()
              }
              maxDate={
                propertyData?.availability_end
                  ? moment(propertyData?.availability_end).toDate()
                  : undefined
              }
              excludeDate={(date) => {
                const disabledDates = getDisabledDates(
                  propertyData.booked_dates
                );
                return disabledDates.some(
                  (disabledDate) =>
                    date.getFullYear() === disabledDate.getFullYear() &&
                    date.getMonth() === disabledDate.getMonth() &&
                    date.getDate() === disabledDate.getDate()
                );
              }}
            />
            <span className="text-red-500 text-xs">{error}</span>
            <FormItem label="Select Guest" className="mt-4">
              <SelectGuests
                className={"flex-1"}
                room={{}}
                maxGuests={isGuestAllowed ? 15 : maximumGuests}
                formik={formik}
                disabled={
                  typeof propertyData?.next_available_date === "string" &&
                  propertyData.next_available_date !== formattedDate
                }
              />
            </FormItem>
            {startDate && endDate && (
              <div className="flex flex-col space-y-4">
                <div className="border-b border-neutral-200 dark:border-neutral-700" />
                <div className="flex justify-between text-neutral-600 dark:text-neutral-300">
                  <div className="flex items-center space-x-2">
                    <span className="text-lg font-medium">
                      First Month Rent
                    </span>
                    <div className="relative flex items-center">
                      <i
                        data-tooltip-id="info-tooltip"
                        className="text-2xl las la-info-circle"
                      ></i>

                      <Tooltip
                        id="info-tooltip"
                        place="top"
                        content="This deposit will be transfered to host until 24 hours after your check in to the property"
                        noArrow={false}
                        style={{
                          backgroundColor: "#f97316",
                          color: "white",
                          borderRadius: "0.375rem",
                          padding: "0.25rem 0.5rem",
                          maxWidth: "150px",
                          textAlign: "center",
                          fontSize: "0.75rem",
                        }}
                      />
                    </div>
                  </div>
                  <span>
                    {`${currencySymbol()} ${
                      Number(pricePerMonth)?.toFixed(2) || "N/A"
                    }`}
                  </span>
                </div>
                {isGuestAllowed && extraGuest && (
                  <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    <span>Cost of {extraGuest} extra guests</span>
                    <span>
                      {`${currencySymbol()} ${
                        Number(extraAmount)?.toFixed(2) || "N/A"
                      }`}
                    </span>
                  </div>
                )}
                <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                  <div className="flex items-center space-x-2">
                    <span className="text-lg font-medium">
                      One-Time Service fee
                    </span>
                    <div className="relative flex items-center">
                      <i
                        data-tooltip-id="tooltip-service-fee"
                        className="text-2xl las la-question-circle cursor-pointer"
                      ></i>

                      <Tooltip
                        id="tooltip-service-fee"
                        place="top"
                        content="This is a one-time fee that allows us to provide assistance and customer support. Furthermore, secure your payment and guarantee your accommodation."
                        noArrow={false}
                        style={{
                          backgroundColor: "#f97316",
                          color: "white",
                          borderRadius: "0.375rem",
                          padding: "0.25rem 0.5rem",
                          maxWidth: "150px",
                          textAlign: "center",
                          fontSize: "0.75rem",
                        }}
                      />
                    </div>
                  </div>
                  <span>
                    {`${currencySymbol()} ${
                      Number(serviceFees)?.toFixed(2) || "N/A"
                    }`}
                  </span>
                </div>
                <div className="flex justify-between font-semibold">
                  <span>Total</span>
                  <span>
                    {`${currencySymbol()} ${
                      Number(totalAmount)?.toFixed(2) || "N/a"
                    }`}
                  </span>
                </div>
              </div>
            )}
            <div className="w-full flex flex-col space-y-4 mt-5">
              <ButtonPrimary
                disabled={isButtonDisabled || !!error}
                onClick={() => handleSubmit(formik.values)}
                loading={isLoading}
              >
                Reserve
              </ButtonPrimary>
              <ButtonPrimary
                onClick={handleChatButtonClick}
                disabled={
                  !isAuthenticated() ||
                  (typeof propertyData?.next_available_date === "string" &&
                    propertyData.next_available_date !== formattedDate)
                }
              >
                Contact Host
              </ButtonPrimary>
            </div>
          </form>
          {infoModal && (
            <CommonModal
              isOpen={infoModal}
              onClose={() => setInfoModal(false)}
              description={modalDescription}
            />
          )}
         {isModalOpen && (
  <ContactOwnerModal
    isOpen={isModalOpen}
    onClose={handleCloseModal}
    onSend={handleSendMessage}
    propertyData={propertyData}
    selectedRoom={selectedRoom}  // ✅ Add this - you already have it in state
    roomHasAvailability={
      selectedRoom 
        ? selectedRoom.to_book && selectedRoom.status !== 'inactive'
        : true  // or false, depending on default behavior you want
    }  // ✅ Add this to properly enable/disable date pickers
  />
)}
        </div>
      </>
    );
  };

  // Define MobileBookingBar component in the same file
  /*const MobileBookingBar: React.FC<{
    selectedRoom: any;
    propertyData: any;
    onOpenSheet: () => void;
  }> = ({ selectedRoom, propertyData, onOpenSheet }) => {
    if (!selectedRoom) return null;

    return (
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white dark:bg-neutral-900 border-t-2 border-gray-200 dark:border-neutral-700 shadow-lg">
        <button
          onClick={onOpenSheet}
          className="w-full px-4 py-4 flex items-center justify-between"
        >
          <div className="flex-1 text-left">
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Selected Room
            </p>
            <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
              {selectedRoom.name}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-lg font-bold text-[#f5694b]">
                ${selectedRoom.price}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                per month
              </p>
            </div>
            <ChevronUp size={24} className="text-gray-400" />
          </div>
        </button>
      </div>
    );
  };*/

  // Add this new component after MobileBookingSheet
  const FloatingBookingButton: React.FC<{
    selectedRoom: any;
    onClick: () => void;
  }> = ({ selectedRoom, onClick }) => {
    if (!selectedRoom) return null;

    return (
      <button
        onClick={onClick}
        className="fixed bottom-20 right-4 z-50 lg:hidden bg-gradient-to-r from-[#f5694b] to-[#e5593b] text-white rounded-full shadow-2xl px-6 py-4 flex items-center gap-3 hover:shadow-xl transition-all active:scale-95"
      >
        <Calendar size={20} />
        <div className="text-left">
          <p className="text-xs font-medium opacity-90">Book Now</p>
          <p className="text-sm font-bold">
            ${selectedRoom.price_per_month}/mo
          </p>
        </div>
      </button>
    );
  };

  const MobileBookingSheet: React.FC<{
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
  }> = ({ isOpen, onClose, children }) => {
    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
      }

      return () => {
        document.body.style.overflow = "unset";
      };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-[100] lg:hidden">
        {/* Header with close button */}
        <div className="bg-white dark:bg-neutral-900 border-b border-gray-200 dark:border-neutral-700 px-4 py-4 flex items-center justify-between shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Booking Details
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-neutral-800 rounded-full transition-colors"
            aria-label="Close booking details"
          >
            <svg
              className="w-6 h-6 text-gray-600 dark:text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="bg-white dark:bg-neutral-900 h-[calc(100vh-64px)] overflow-y-auto">
          <div className="px-4 py-6">{children}</div>
        </div>
      </div>
    );
  };

  if (!propertyData) return null;
  return (
    <div className="nc-ListingStayDetailPage">
       <SEO
      title={`${propertyData.title} - Student Accommodation in Lima`}
      description={`${propertyData.title} in Lima, Peru. ${propertyData.description?.slice(0, 120) || "Verified student accommodation. Book online instantly."}`}
      canonical={`/listing-stay-detail/${propertyData.slug}`}
      ogImage={propertyData.cover_image?.url || undefined}
    />
    <JsonLd
      schema={{
        "@context": "https://schema.org",
        "@type": "LodgingBusiness",
        "name": propertyData.title,
        "description": propertyData.description || "",
        "url": `https://www.nomadroof.com/listing-stay-detail/${propertyData.slug}`,
        "image": propertyData.cover_image?.url
          ? [propertyData.cover_image.url]
          : propertyData.place_images?.slice(0, 3) || [],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": propertyData.address || "",
          "addressLocality": propertyData.city || "Lima",
          "addressRegion": propertyData.state || "Lima",
          "addressCountry": propertyData.country || "PE",
          ...(propertyData.zipcode ? { "postalCode": propertyData.zipcode } : {}),
        },
        ...(propertyData.latitude && propertyData.longitude ? {
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": propertyData.latitude,
            "longitude": propertyData.longitude,
          }
        } : {}),
        ...(propertyData.average?.count > 0 ? {
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": Number(propertyData.average.average_review).toFixed(1),
            "reviewCount": propertyData.average.count,
            "bestRating": "5",
            "worstRating": "1",
          }
        } : {}),
        ...(propertyData.price_per_month ? {
          "priceRange": `From $${propertyData.price_per_month} USD/month`,
        } : {}),
        "amenityFeature": (propertyData.amenities || []).map((a: any) => ({
          "@type": "LocationFeatureSpecification",
          "name": a.name,
          "value": true,
        })),
        "checkinTime": "14:00",
        "checkoutTime": "12:00",
        "currenciesAccepted": "USD",
        "paymentAccepted": "Credit Card",
        "touristType": "Students, Erasmus",
      }}
    />
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold py-5">
        {propertyData.title}
      </h2>
      <div className="flex items-center flex-wrap gap-3 mb-5">
          <StartRating propertyData={propertyData} />
          
          {(propertyData?.average?.count || 0) > 0 && sortAddress && (
            <span className="text-neutral-300 dark:text-neutral-600">·</span>
          )}
          
          {sortAddress && (
            <div className="flex items-center text-sm text-neutral-600 dark:text-neutral-400">
              <i className="las la-map-marker-alt text-lg"></i>
              <span className="ml-1.5">{sortAddress}</span>
            </div>
          )}
        </div>
      <PropertyImageGallery
        coverImage={propertyData.cover_image}
        placeImages={propertyData.place_images || []}
        propertyTitle={propertyData.title}
        onOpenGallery={handleOpenModalImageGallery}
      />

      <main className="relative z-10 mt-11 flex flex-col lg:flex-row">
        {/* LEFT SIDE - MAIN CONTENT */}
        <div className="w-full lg:w-3/4 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          <RenderSectionDetails
            propertyData={propertyData}
            slug={slug || ""}
            setPropertyData={setPropertyData}
          />

          <PropertyDescription propertyData={propertyData} />

          <AmenitiesFeatures
            propertyData={propertyData}
            openModalAmenities={openModalAmenities}
            isOpenModalAmenities={isOpenModalAmenities}
            closeModalAmenities={closeModalAmenities}
          />

          <RoomsListSection
            rooms={propertyData.rooms}
            startDate={storedSearchData?.startDate}
            endDate={storedSearchData?.endDate}
            maxResidents={propertyData.guest_number}
            onRoomSelect={handleRoomSelect} // Pass the handler down
            propertyData={propertyData}
          />

          <Policy propertyData={propertyData} />
          {/* ADD THIS NEW SECTION */}
          <FinancialDetails propertyData={propertyData} />
          <Universities propertyData={propertyData} />

           <Recommendations propertyData={propertyData} />

          <ListingMap propertyData={propertyData} userLocation={userLocation} />

          <Cancellation propertyData={propertyData} />

          <Roomies propertyData={propertyData} />

          <Review propertyData={propertyData} />

          <HostInformation propertyData={propertyData} />

          <SimilarProperty propertyData={propertyData} />

          {/*  <SectionDateRange
      availabilityStart={moment(
        moment(propertyData?.availability_start).isAfter(moment())
          ? propertyData?.availability_start
          : new Date()
      ).toDate()}
      availabilityEnd={
        propertyData?.availability_end
          ? moment(propertyData?.availability_end).toDate()
          : undefined
      }
      booked_dates={propertyData?.booked_dates || []}
    /> */}

          {/*   <RenderSection9 /> */}

          <ImageModal
            isOpen={imageModal}
            onClose={closeImageModal}
            propertyData={propertyData}
          />
        </div>

        {/* RIGHT SIDE - STICKY SIDEBAR AREA */}
        <div className="w-full lg:w-1/4 xl:w-1/3 mt-10 lg:mt-0 space-y-8">
          {/* HIDDEN AvailabilitySidebar for now */}
          <div className="hidden">
            <AvailabilitySidebar
              onDateChange={(start, end) => {
                console.log("Selected dates:", start, end);
              }}
            />
          </div>

          {/* Show only RenderSidebar */}
          <div className="sticky top-28">
            <BookingSideBar
              propertyData={propertyData}
              propertySlug={propertySlug} // Changed from propertyId
              currentUser={currentUser}
              formattedDate={formattedDate}
              handleChatButtonClick={handleChatButtonClick}
              setInfoModal={setInfoModal}
              infoModal={infoModal}
              setModalDescription={setModalDescription}
              modalDescription={modalDescription}
              isModalOpen={isModalOpen}
              handleCloseModal={handleCloseModal}
              handleSendMessage={handleSendMessage}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              rooms={propertyData.rooms}
              selectedRoom={selectedRoom} // Pass the selected room
            />
          </div>
        </div>
      </main>

      {/* MOBILE STICKY BOTTOM BAR */}
      {/*  <MobileBookingBar
        selectedRoom={selectedRoom}
        propertyData={propertyData}
        onOpenSheet={() => setIsMobileSheetOpen(true)}
      /> */}

      {/* ✅ ADD THIS - Floating button to reopen sheet */}
      {selectedRoom && !isMobileSheetOpen && (
        <FloatingBookingButton
          selectedRoom={selectedRoom}
          onClick={() => setIsMobileSheetOpen(true)}
        />
      )}

      {/* Mobile Bottom Sheet */}
      {selectedRoom && (
        <MobileBookingSheet
          isOpen={isMobileSheetOpen}
          onClose={() => setIsMobileSheetOpen(false)}
        >
          <BookingSideBar
            propertyData={propertyData}
            propertySlug={propertySlug}
            currentUser={currentUser}
            formattedDate={formattedDate}
            handleChatButtonClick={handleChatButtonClick}
            setInfoModal={setInfoModal}
            infoModal={infoModal}
            setModalDescription={setModalDescription}
            modalDescription={modalDescription}
            isModalOpen={isModalOpen}
            handleCloseModal={handleCloseModal}
            handleSendMessage={handleSendMessage}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            rooms={propertyData.rooms}
            selectedRoom={selectedRoom}
            onBookingStart={() => setIsMobileSheetOpen(false)}
          />
        </MobileBookingSheet>
      )}
    </div>
  );
};
export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
